import Vue from 'vue'
import App from './App.vue'
import router from './router'
import TopSearch from '../src/index.js'
import {VueJsonp} from 'vue-jsonp'
// 引入 ivew 组件
import './plugins/iview';
import 'view-design/dist/styles/iview.css';
Vue.config.productionTip = false

Vue.use(VueJsonp)
Vue.use(TopSearch)

new Vue({
  router,
  render: h => h(App)
}).$mount('#wf-topsearch-awepihn-app')
